<div class="col-12 lg:col-12">
  <div>
    <p-tabView [(activeIndex)]="paymentMethodIndex" (onChange)="onTabChange($event)">
      <p-tabPanel header="Pay by credit card">
        <div class="grid">
          <div class="col-12">
            <div id="card-name-field-container"></div>
          </div>
          <div class="col-12">
            <div id="card-number-field-container"></div>
          </div>
          <div class="col-6">
            <div id="card-expiry-field-container"></div>
          </div>
          <div class="col-6">
            <div id="card-cvv-field-container"></div>
          </div>
        </div>

        <tj-payment-summary
          [netAmount]="paymentDetails.netAmount"
          [ccFee]="paymentDetails.ccFee"
          [total]="paymentDetails.total"
          [taxAmount]="paymentDetails.taxFee"
          [showTax]="paymentDetails.applyTax"
          [showCCFee]="paymentDetails.applyCCFee"
          [taxRate]="paymentDetails.taxRate"
        ></tj-payment-summary>

        <div class="flex justify-content-between mt-4">
          <button
            pButton
            label="Back"
            type="button"
            class="p-button-secondary"
            (click)="onBackToPayment()"
          ></button>
          <button
            pButton
            label="Pay"
            type="button"
            class="p-button-primary"
            [disabled]="
              !form.valid || !cardFields || isSubmitting || form.errors?.['cardFieldsEmpty']
            "
            (click)="onSubmitByCard()"
          ></button>
        </div>
      </p-tabPanel>

      <p-tabPanel header="Charge saved card / vault id">
        <div class="grid">
          <div class="col-12">
            <div class="field">
              <label for="vaultId">Vault ID</label>
              <input
                id="vaultId"
                type="text"
                pInputText
                [(ngModel)]="vaultId"
                [disabled]="isSubmitting"
              />
            </div>
          </div>
        </div>

        <div class="flex justify-content-between mt-4">
          <button
            pButton
            label="Back"
            type="button"
            class="p-button-secondary"
            (click)="onBackToPayment()"
          ></button>
          <button
            pButton
            label="Pay"
            type="button"
            class="p-button-primary"
            [disabled]="!vaultId || isSubmitting"
            (click)="onSubmitByVaultId()"
          ></button>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
